import React from "react";
import { withRouter } from "react-router";
import CadeteriaAgregarCadete from "./CadeteriaAgregarCadete";
const BetaEditarCadeteCadeteria = props => {
    return <CadeteriaAgregarCadete editar={true} />;
};

export default withRouter(BetaEditarCadeteCadeteria);
